// src/pages/MyIncome.jsx
import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import adimage1 from '../../assets/pageimages/roomanywhere/raindeximg1.png';
import adimage2 from '../../assets/navlogo.png';

const MyIncome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Referral");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/dashboard");
  };

  const groupNames = [
    { label: "Digital Products Referral", emoji: "🤝", link: "/booksmlmincomecredits" },
    { label: "Physical Products Referral", emoji: "🤝", link: "/nonebooksmlmincomecredits" },
    { label: "Reseling", emoji: "🛒", link: "/mynomlmincomecredits/reselling" },
    { label: "Content Creation", emoji: "🎬", link: "/mynomlmincomecredits/content" },
    { label: "Authoring", emoji: "✍️", link: "/mynomlmincomecredits/authoring" },
    { label: "Counselling", emoji: "🧠", link: "/mynomlmincomecredits/counselling" },
    { label: "Consulting", emoji: "📊", link: "/mynomlmincomecredits/consulting" },
    { label: "Boutique Advisory", emoji: "💎", link: "/mynomlmincomecredits/boutique" },
    { label: "Franchise", emoji: "🏪", link: "/mynomlmincomecredits/franchise" },
    { label: "Readfluencing", emoji: "📖", link: "/mynomlmincomecredits/readfluencing" },
    { label: "Internship", emoji: "🧑‍💼", link: "/mynomlmincomecredits/internship" },
    { label: "Ad View", emoji: "👁️", link: "/mynomlmincomecredits/adview" },
    { label: "Video View", emoji: "📺", link: "/mynomlmincomecredits/videoview" },
    { label: "Donations", emoji: "💝", link: "/mynomlmincomecredits/donations" },
    { label: "Institutional", emoji: "🏛️", link: "/mynomlmincomecredits/institutional" },
    { label: "Others", emoji: "🧩", link: "/mynomlmincomecredits/others" },
    { label: "About", emoji: "ℹ️", link: "/myincomecredits-about" },
  ];

  const menuButtons1 = [
    // 🤝 Referral
    { label: "Direct", emoji: "🤝", link: "/mymlmincomecredits/direct", group: "Referral" },

    { label: "L1", emoji: "🥇", link: "/mymlmincomecredits/l1", group: "Referral" },
    { label: "L2", emoji: "🥈", link: "/mymlmincomecredits/l2", group: "Referral" },
    { label: "L3", emoji: "🥉", link: "/mymlmincomecredits/l3", group: "Referral" },

    { label: "L4", emoji: "🌿", link: "/mymlmincomecredits/l4", group: "Referral" },
    { label: "L5", emoji: "🌳", link: "/mymlmincomecredits/l5", group: "Referral" },
    { label: "L6", emoji: "🪴", link: "/mymlmincomecredits/l6", group: "Referral" },
    { label: "L7", emoji: "🌲", link: "/mymlmincomecredits/l7", group: "Referral" },
    { label: "L8", emoji: "🪵", link: "/mymlmincomecredits/l8", group: "Referral" },

    { label: "One Time", emoji: "🪵", link: "/mymlmincomecredits/onetime", group: "Referral" },
    { label: "Franchise", emoji: "🪵", link: "/mymlmincomecredits/franchise", group: "Referral" },   
];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 [&_p]:text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">My Income Credits</div>
          <div className="text-[11px] text-gray-200">Think5Whys Micro Digital Income Initiative for the World!</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}

      <div
        className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
        onClick={() => navigate("/roomanywhere")}
        >
            <div className="flex-shrink-0 w-20 h-20 rounded overflow-hidden bg-gray-700">
                <img
                src={adimage1} 
                alt="Ad"
                className="w-full h-full object-cover"
                />
            </div>
            <div className="flex flex-col text-left">
                <p className="text-xs uppercase text-gray-400 mb-1">Think5Whys Ad</p>
                <p className="font-semibold text-lg"><span className="text-yellow-200">RoomAnywhere</span>: Make Indoor and Outdoor Room (Patent Applied)</p>
                <p className="text-sm mt-1">Click to see more!</p>
            </div>
      </div>   

      <div className="mt-1 mb-1 px-3 py-2 border-b border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-2  border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => {
                if (group.link) {
                    navigate(group.link);
                } else {
                    setActiveTab(group.label);
                }
              }}
              className={`flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-xs lg:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-teal-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-4 lg:grid-cols-6 gap-1 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-[10px] text-xs lg:text-sm font-medium transition bg-transparent hover:bg-teal-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-base sm:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>
      <div
        className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
        onClick={() => window.open("https://www.think5whys.com", "_blank")}
        >
        <div className="flex-shrink-0 w-16 h-16 bg-gray-700 rounded overflow-hidden">
            <img
                src={adimage2}
                alt="Ad"
                className="w-full h-full object-cover"
            />
            </div>

            <div className="flex flex-col text-left">
            <p className="text-xs uppercase text-gray-400 mb-1">Google Ad</p>
            <p className="font-semibold text-lg">Think5Whys: Your Platform for Transformation</p>
            <p className="text-sm mt-1">Click to see more!</p>
        </div>
      </div>         
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MyIncome;
